import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { MdrCustomerPanelDataProviderFactory } from '../factory/MdrCustomerPanelDataProviderFactory';
import { MdrCustomerPanelBaseDataProvider } from '../dataProvider/MdrCustomerPanelBaseDataProvider';
import { CompanyData } from '../../../company/types/company-data';

export class MdrCustomerPanelRepository extends BaseWebComponentRepository {
  public dataProviderFactory: MdrCustomerPanelDataProviderFactory;
  public dataProvider: MdrCustomerPanelBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new MdrCustomerPanelDataProviderFactory(),
    });
  }

  public async getMyCompanyData(): Promise<CompanyData> {
    return this.dataProvider.getMyCompanyData();
  }
}
